'use client';

import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SignatureMedalItem } from '@/types/achievements';
import ImageAdaptive from '@/components/ImageAdaptive';

interface SignatureMedalProps {
    medal?: SignatureMedalItem | null;
}
export default function SignatureMedal({ medal }: SignatureMedalProps) {
    const [medalUrl, setMedalUrl] = useState<string>();

    useEffect(() => {
        if (medal?.medal_resource_url) {
            setMedalUrl(medal?.medal_resource_url);
        }
    }, [medal]);

    return (
        <>
            {medal?.medal_resource_url === undefined ||
            medal?.medal_resource_url === null ||
            medal?.medal_resource_url === '' ? (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5, delay: 0.5 }}
                        className="flex flex-row"
                    >
                        <div className="flex flex-col relative">
                            <div className="flex flex-col justify-center items-center w-[160px] h-[140px] lg:w-[200px] lg:h-[170px]">
                                <ImageAdaptive
                                    src={'/images/achievement/medal/medal-0.svg'}
                                    baseWidth={112}
                                    breakpoints={{ lg: 140 }}
                                />
                            </div>
                            <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                <ImageAdaptive
                                    src={'/images/achievement/medal/medal-0-lock.svg'}
                                    baseWidth={40}
                                    breakpoints={{ lg: 50 }}
                                />
                            </div>
                        </div>
                    </motion.div>
                </>
            ) : (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5, delay: 0.5 }}
                        className="flex flex-row"
                    >
                        <div className="flex flex-col">
                            <div className="flex flex-col justify-center items-center w-[250px] h-[220px] relative">
                                <ImageAdaptive
                                    src={'/images/achievement/medal/frame/medal-frame.svg'}
                                    baseWidth={170}
                                    className="absolute"
                                />
                                <img src={medalUrl} className="absolute -top-[40px] lg:-top-[40px]" />
                            </div>
                            <div className="flex justify-center items-center font-corp font-bold text-xs text-color-base">
                                <ImageAdaptive
                                    src={`/images/achievement/medal/medal-${medal?.achievement_score}.svg`}
                                    baseWidth={30}
                                />
                                {medal?.medal_name}
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </>
    );
}
